
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/ocean-technology/products/marine-protected-area-management-systems",
      function () {
        return require("private-next-pages/industries/ocean-technology/products/marine-protected-area-management-systems.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/ocean-technology/products/marine-protected-area-management-systems"])
      });
    }
  